import { AppBar, Button, Switch, Toolbar, Typography } from "@mui/material";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CTM_Colors } from "../Helper";

const switch_xs = {
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: CTM_Colors.dark_grey,
        '&:hover': {
            backgroundColor: 'rgba(128, 128, 128, 0.08)',
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: CTM_Colors.dark_grey,
    },
};

interface CTM_AppBarProps {
    theme: boolean;
    onChange: (arg0: boolean) => void
    logoutHandler: () => void
}

const CTM_AppBar: React.FC<CTM_AppBarProps> = ({ theme, onChange, logoutHandler }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const isSessionsActive = location.pathname === '/' || location.pathname.startsWith('/session');
    const isDashboardActive = location.pathname === '/dashboard';

    const navBtn = (active: boolean) => ({
        color: 'black',
        mr: 2,
        fontWeight: active ? 700 : 400,
        borderBottom: active ? '2px solid black' : '2px solid transparent',
        borderRadius: 0,
    });

    const handleClick = () => {
        navigate("/");
    }
    return (
        <AppBar position="sticky" style={{ backgroundColor: CTM_Colors.ctm_green, color: 'black', backgroundImage: "none" }}>
            <Toolbar>
                <img
                    src="/logo.webp"
                    alt="CTM Logo"
                    style={{
                        height: '40px',
                        marginRight: '20px',
                        cursor: 'pointer',
                    }}
                    onClick={handleClick}
                />
                <Typography variant="h6" style={{ flexGrow: 1 }}>
                    CTM Test Logger
                </Typography>
                <Button variant="text" onClick={() => navigate("/")} sx={navBtn(isSessionsActive)}>
                    Sessions
                </Button>
                <Button variant="text" onClick={() => navigate("/dashboard")} sx={navBtn(isDashboardActive)}>
                    Dashboard
                </Button>
                <Switch checked={theme} sx={switch_xs} onChange={(event) => onChange(event.target.checked)} />
                <Button variant="contained" color="primary" onClick={logoutHandler} sx={{ boxShadow: 'none' }}>Logout</Button>
            </Toolbar>
        </AppBar>
    )
}

export default CTM_AppBar;